import { footerFetcher } from '@api/fetcher/ambassdor'
import { useQuery } from '@tanstack/react-query'

interface ReturnType {
  data: any
  isLoading: boolean
  error: unknown
  isFetching: any
}


const useFooter = (): ReturnType => {
  const { isLoading, error, data, isFetching } = useQuery(
    ['ambassdor-footer-fetcher'],
    footerFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )
  return {
    error,
    isLoading,
    data,
    isFetching,
  }
}

export default useFooter
